import { useMemo } from "react";

import { PutawayTaskCantInductReasons } from "~/features/autostorePutaway/autostorePutaway.types";
import { getPutawayTaskCantInductReasons } from "~/features/autostorePutaway/autostorePutaway.utils";
import { Guid, PutAwayTaskSummaryDto } from "~/types/api";

export type UseCantInductReasonsResult = PutawayTaskCantInductReasons;

/**
 * Memoized cant induct reasons data for a putaway task.
 */
export const useCantInductReasons = (
  putawayTask?: PutAwayTaskSummaryDto | null
): UseCantInductReasonsResult => {
  return useMemo(
    () => getPutawayTaskCantInductReasons(putawayTask),
    [putawayTask]
  );
};

/**
 * Memoized ineligibility flags for a list of putaway tasks.
 */
export const useCantInductIneligibilityByPutawayTaskId = (
  putawayTasks: PutAwayTaskSummaryDto[]
): ReadonlyMap<Guid, boolean> => {
  return useMemo(() => {
    const ineligibleByPutawayTaskId = new Map<Guid, boolean>();

    for (const putawayTask of putawayTasks) {
      ineligibleByPutawayTaskId.set(
        putawayTask.putAwayTaskId,
        getPutawayTaskCantInductReasons(putawayTask).isPutawayTaskIneligible
      );
    }

    return ineligibleByPutawayTaskId;
  }, [putawayTasks]);
};
